<div id="preloader" aria-hidden="true">
  <div class="jumper" aria-hidden="true"><div></div><div></div><div></div></div>
</div>

<section id="login" class="py-5">
  <div class="login-wrapper">
    <div class="container">
      <div id="login-row" class="row justify-content-center align-items-center min-vh-100">
        <div id="login-column" class="col-lg-5 col-md-7 col-sm-9 col-11">

          <div id="login-box" class="card shadow-lg rounded-lg">

            <!-- Brand -->
            <div class="card-header text-center bg-gradient text-white rounded-top">
              <div class="navbar-brand mb-1 d-block" aria-label="Upcoming Cars">
                <i class="fas fa-car fa-lg me-2"></i>
                <span class="fw-700">Upcoming</span><span class="text-warning fw-700"> Cars</span>
              </div>
              <p class="small mb-0 opacity-85">Welcome back — sign in to continue</p>
            </div>

            <!-- Body -->
            <div class="card-body">
              <form #loginform="ngForm" id="login-form" class="form" (ngSubmit)="doLogin()" novalidate>
                <small class="text-danger d-block mb-3" *ngIf="msg">{{ msg }}</small>

                <!-- Username -->
                <div class="form-group mb-3">
                  <label for="username" class="form-label fw-600">Username</label>
                  <div class="input-group align-items-center">
                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                    <input type="text" name="username" id="username" class="form-control form-control-modern" placeholder="you@example.com" [(ngModel)]="user.username" required #username="ngModel" [attr.aria-invalid]="username.invalid && loginform.submitted">
                  </div>
                  <div *ngIf="loginform.submitted && username.invalid" class="form-text text-danger">Please enter your username</div>
                </div>

                <!-- Password -->
                <div class="form-group mb-2">
                  <label for="password" class="form-label fw-600">Password</label>
                  <div class="input-group align-items-center">
                    <span class="input-group-text"><i class="fas fa-lock"></i></span>
                    <input type="password" name="password" id="password" class="form-control form-control-modern" placeholder="Your secure password" [(ngModel)]="user.password" required minlength="6" #password="ngModel" [attr.aria-invalid]="password.invalid && loginform.submitted">
                    <button type="button" class="btn btn-link btn-sm ms-2" style="white-space:nowrap" (click)="$event.preventDefault();">Forgot?</button>
                  </div>
                  <div *ngIf="loginform.submitted && password.invalid" class="form-text text-danger">Please enter a valid password</div>
                </div>

                <!-- Actions -->
                <div class="d-flex align-items-center justify-content-between my-3">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="remember-me" name="remember-me">
                    <label class="form-check-label small" for="remember-me">Remember me</label>
                  </div>
                  <div class="small text-muted">Need help? <a [routerLink]="['/notification']" class="text-decoration-underline">Contact Support</a></div>
                </div>

                <button type="submit" class="btn btn-primary w-100 fw-600 mb-3 d-flex justify-content-center" [disabled]="isLoading">
                  <span *ngIf="isLoading" class="btn-spinner me-2" aria-hidden="true"></span>
                  <span *ngIf="!isLoading">Sign In</span>
                  <span *ngIf="isLoading">Signing In…</span>
                </button>

                <!-- Social -->
                <div class="text-center mb-3">
                  <small class="text-muted">or continue with</small>
                  <div class="d-flex gap-2 justify-content-center mt-2">
                    <button type="button" class="btn btn-outline-secondary social-btn" (click)="$event.preventDefault()"><i class="fab fa-google me-2"></i>Google</button>
                    <button type="button" class="btn btn-outline-secondary social-btn" (click)="$event.preventDefault()"><i class="fab fa-github me-2"></i>GitHub</button>
                  </div>
                </div>

                <div id="register-link" class="text-center">
                  <p class="small mb-2">New here? <a [routerLink]="['/registration']" class="text-primary fw-600">Create an account</a></p>
                </div>
              </form>
            </div>

            <div class="card-footer text-center small text-muted">&copy; 2025 piyushkumaranand</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>